export const INSTALLATION_ASIN = "IG-5X-601-PIN";

export function isInstallationAsin(sku) {
  return sku === INSTALLATION_ASIN;
}

export function hasInstallationAsin(orderItems) {
  return (orderItems || []).some((item) => item.sku === INSTALLATION_ASIN);
}
